import { useQuery } from '@tanstack/react-query';
import { useApi } from './useApi';

export const usePositions = () => {
  const api = useApi();
  return useQuery<string[]>(['positions'], () => api.getExcludedPositions(), {
    keepPreviousData: true,
  });
};
